import { createSlice } from "@reduxjs/toolkit";

export const centerListSlice = createSlice({
  name: "centerList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedCenter: null,
    filteredRecords: 0,
    isSingleCenterLoading: false,
    isLoading: false,
    isAnswerByTechTeam: false,
    isSingleCenterNotFound: false,
  },
  reducers: {
    setAllCenterLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleCenterLoadingState: (state, action) => {
      state.isSingleCenterLoading = true;
    },
    loadAllCenter: (state, action) => {
      const listObj = {};
      action.payload.centres.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.centres.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleCenter: (state, action) => {
      state.selectedCenter =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleCenterLoading = false;
    },
    setSingleCenterNotFound: (state, action) => {
      state.isSingleCenterNotFound = action.payload;
    },
  },
});

export const {
  setAllCenterLoadingState,
  setSingleCenterLoadingState,
  loadAllCenter,
  loadSingleCenter,
  setSingleCenterNotFound,
} = centerListSlice.actions;

export default centerListSlice.reducer;
